// extracted by mini-css-extract-plugin
export default {"root":"iuyPk","items":"Fzchc","item":"_1t3rv","is-selected":"_1rveA","isSelected":"_1rveA","user":"_3ghzr"};